import React from 'react';

import useNavbarHeight from './useNavbarHeight';

const NavbarSpacer = () => {
  const { navbarHeight } = useNavbarHeight();

  return <div style={{ height: navbarHeight }} />;
};

export default NavbarSpacer;
